<template>
  <div :class="targetClass">
    <no-ssr>
      <mq-layout mq="m1200+">
        <slot />
      </mq-layout>
    </no-ssr>
  </div>
</template>

<script>
import NoSSR from "vue-no-ssr";

export default {
  name: "ResponsiveDesktop",
  components: {
    "no-ssr": NoSSR,
  },
  props: {
    targetClass: {
      default: "",
    },
  },
}
</script>
